'use strict';

var UserManagementConstants = {
  SCREEN_VALUE: {
    MANAGE_USERS: 'manage-users',
    ROLE_MANAGEMENT: 'role-management',
    WORKFLOW_DEFAULT_SETTINGS: 'workflow-default-settings',
    DATE_TIME_NUMBER_FORMAT: 'date-time-format',
    DATE_TIME_NUMBER_DEFAULT_FORMAT: 'date-time-default-format'
  },
  MANAGE_USERS_SCREENS: {
    USER_PROFILE: 'user-profile',
    MARKETS_LEGS: 'markets-legs',
    WORKFLOW_SETTINGS: 'workflow-settings',
    DATE_TIME_NUMBER_PREFS: 'date-time-number-prefs',
    MANAGE_ACCESS_REQUESTS: 'manage-access-requests',
    PENDING_USER_REQUEST: 'pending-user-request'
  },
  USER_PROFILE_SCREENS: {
    USER_PROFILE: 'default',
    MARKETS_LEGS: 'markets-legs',
    WORKFLOW_SETTINGS: 'workflow-settings',
    DATE_TIME_NUMBER_PREFS: 'date-time-number-prefs'
  },
  MANAGE_ROLES_SCREENS: {
    EDIT_ROLE: 'create-or-edit-role',
    VIEW_DEFAULT_ROLE: 'view-default-role'
  }
};
module.exports = UserManagementConstants;